import React from "react"
import { injectIntl } from "react-intl"
import GlobalHelper from "../../common/GlobalHelper"
import SideBar from "../../common/layout/sidebar.component"
import InvoicesTabs from "../../common/layout/tabs/invoices.component"
import GenericListing from "../../common/listing/generic-listing/GenericListing"
import { ObjectType } from "../../state/listing/generic-listing"

const CreditMemoListing = () => {

    SideBar.activateMenu("invoice")

    return (
        <>
            <InvoicesTabs />
            <GenericListing
                objectType={ObjectType.CREDIT_MEMOS}
                selectableRows={!GlobalHelper.isEnvProduction()}
            />
        </>
    )
}

export default injectIntl(CreditMemoListing)


// WEBPACK FOOTER //
// ./src/invoice/credit-memo/CreditMemoListing.tsx